import { React } from '@1337lawyers/design';

const SettingsEdit = () => {
  return <React.Fragment>Edit your settings</React.Fragment>;
};

export default SettingsEdit;
